import React from 'react'
import {Stack} from "@chakra-ui/react";
import {SimpleStatProps} from "./simple-stat";
import {SimpleStatWrapper} from "./simple-stat-wrapper";

export const SimpleStatSkeleton = ({ LoadingComponent,...props }: Partial<SimpleStatProps> & {
  LoadingComponent: React.ReactNode;
}) => {
  return (
    <SimpleStatWrapper {...props}>
      <Stack h="100px" w="178px" align="center" justify="center">
        {LoadingComponent}
      </Stack>
    </SimpleStatWrapper>
  );
};
